import React, { FC, useState } from 'react';
import { isEmpty } from 'lodash';
import { Container } from '@src/components/Container';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import { PasswordInput } from '@src/components/PasswordInput';
import { Button } from '@src/components/Button';
import { useUpdateRecruiterPasswordMutation } from '@src/graphql/generated';
import { getPasswordErrorMessage } from '@src/util/validation';
import { setErrorFlashMessage, setSuccessFlashMessage } from '@src/redux/actions/flashMessages';
import { useAppDispatch } from '@src/redux';
import { Error } from '@src/components/PasswordInput/interfaces/error.interface';
import { removeAccessToken } from '@src/redux/actions/accessToken';
import './styles.scss';

export const Security: FC = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [errors, setErrors] = useState<Error>();

  const dispatch = useAppDispatch();

  const setInitialState = (): void => {
    setNewPassword('');
    setOldPassword('');
    setErrors(undefined);
  };

  const [updatePassword, { loading: isLoading }] = useUpdateRecruiterPasswordMutation({
    onCompleted: () => {
      dispatch(setSuccessFlashMessage('Password successfully updated.'));
      setInitialState();
      dispatch(removeAccessToken());
    },
    onError: () => {
      dispatch(setErrorFlashMessage("Couldn't manage to update password, please try later"));
    },
  });

  const onUpdate = (): void => {
    if (!isEmpty(getPasswordErrorMessage(newPassword))) {
      setErrors(getPasswordErrorMessage(newPassword));

      return;
    }

    if (newPassword === oldPassword) {
      dispatch(setErrorFlashMessage('New password must be different from current password.'));

      return;
    }

    updatePassword({
      variables: {
        newPassword: newPassword.trim(),
        oldPassword: oldPassword.trim(),
      },
    });
  };

  const isUpdateButtonDisabled = !oldPassword || !newPassword || isLoading;

  return (
    <Container className="user-profile-security" type={ContainerType.BORDERED}>
      <div className="user-profile-security__form-wrapper">
        <PasswordInput
          isValidationRulesVisible={false}
          onChange={value => setOldPassword(value)}
          textFieldProps={{
            isDisabled: isLoading,
            placeholder: 'Old password',
          }}
          value={oldPassword}
        />

        <PasswordInput
          errors={errors}
          onChange={value => {
            setNewPassword(value);

            if (errors) {
              setErrors(undefined);
            }
          }}
          textFieldProps={{
            isDisabled: isLoading,
            placeholder: 'New password',
          }}
          value={newPassword}
        />
        <Button className="login-step__continue-button" isDisabled={isUpdateButtonDisabled} onClick={onUpdate}>
          Update
        </Button>
      </div>
    </Container>
  );
};
